/************************************************************
 Professional Namespace
 ************************************************************/

window.ProfessionalNS = {
    acknowledge_co_sign: function(coSignId, callback){
        Hades.showLoading();

        var params = {
            co_sign_id: coSignId
        };

        $.post('/professional/acknowledge_co_sign', params, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if(callback){
                    callback(data);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
};